export default class TimeSignature {
  numerator: number;
  denominator: number;
  /**
   * How many bottom notes each beat of the bar holds (7/8 as 3+2+2 is
   * [3, 2, 2]), when the content or the player overrides the meter's default
   * grouping. Absent means the default (see Models/MeterTiming).
   */
  beatGrouping?: number[];

  constructor(numerator: number, denominator: number, beatGrouping?: number[]) {
    this.numerator = numerator;
    this.denominator = denominator;
    if (beatGrouping !== undefined) {
      this.beatGrouping = beatGrouping;
    }
  }
}
